import $ from 'jquery';

function request(opt) {

  // opt.url += (opt.url.indexOf('?') == -1 ? '?' : '&') + $.param({t: Math.floor((new Date).getTime()/1000), v: '1.0'})
  if (!opt.type) {
    opt.type = 'GET';
  }

  if (opt.type.toUpperCase() == 'POST') {

    if (!opt.contentType) {
      opt.contentType = 'application/json; charset=utf-8'
    }

    if (opt.data && (typeof opt.data === 'object')) {
      opt.data = JSON.stringify(opt.data)
    }

  }

  opt.xhrFields = {withCredentials: true};

  if (!opt.dataType) {
    opt.dataType = 'json'
  }

  return new $.Deferred(defer => {
    $.ajax(opt)
      .done(res => {
        if (res) {
          res.status == 0 ? defer.resolve(res.data) : defer.reject(`${res.msg}(${res.status})`, res.status)
        } else {
          defer.reject('unknown error', 'UNKNOWN')
        }
      })
      .fail((xhr, code) => defer.reject(`网络异常（${code}）`, code))
  })

}

const storageService = ''

// const isProd = __ENV__ == 'prod';

// const baseRequsetUrl = isProd ? '' : __APP_URL__ ;
const baseRequsetUrl = process.env.HUYA_APP_STOREURL


request.api = {
  shopIndexExtList: '/api/appstore/recommendExtList',
  shopIndexExtListV2: '/api/appstore/recommendExtListV2',
  // extDetail: '/api/shop/extDetail',
  extDetail: '/api/appstore/extDetail',
  installExt: '/api/appstore/installExt',
  uninstallExt: '/api/appstore/uninstallExt',
  hadInstall: '/api/appstore/hadInstall',
  extInstallList: '/api/appstore/extInstallList',
  confirmExtensionFeeChange: '/api/appstore/confirmExtensionFeeChange',
  getBuyList: '/api/appstore/extBuyList',
  installFreeExt: '/api/appstore/installExt',
  hadBuyExt: '/api/appstore/isUserBuyExt',
  getExtExpenseAttr: '/api/userBuy/getExtExpenseAttr',
  getHuyaCoinBalance: '/api/userBuy/getUserHuyaCoinBalance',
  installPaidExt: '/api/userBuy/payInstallExpense',
  payServiceExtFee: '/api/userBuy/payServiceExpenseBack',
  detectIsBuySuccessful: '/api/userBuy/isUserBuySuccess',
  getInstallFeeList: '/api/anchorBill/anchorInstallationFeeBill',
  getServiceFeeList: '/api/anchorBill/anchorServiceFeeBill',
  getUnpayList: '/api/anchorBill/anchorServiceBackBill',
  anchorExpenseSummary: '/api/anchorBill/anchorExpenseSummary',
  anchorExpenseDetail: '/api/anchorBill/anchorExpenseDetail',
  getBannerList: '/api/appstoreSocial/getBannerList',
  popularList: '/api/rank/popular',
  richList: '/api/rank/rich',
  tagList: '/api/appstore/tagList',
  extList: '/api/appstore/extList',
  likeExt: '/api/appstoreSocial/extLike',
  unLikeExt: '/api/appstoreSocial/extUnlike',
  tagsList: '/api/appstore/tagList',
}

for (const key in request.api) {
  request.api[key] = baseRequsetUrl + request.api[key];
}

export default request;
